/* eslint-disable react/button-has-type */
/* eslint-disable @typescript-eslint/no-var-requires */
import React, { FunctionComponent, MutableRefObject, useRef } from 'react';

import './animation017.less';
import ImgPoint from '../../../../../assets/animation_point.gif';

interface IAnimation017Item {
  icon: string;
  line?: string;
  color: string;
  number: string;
  text: string;
}

interface IAnimation017Props {
  tip: string;
  items: IAnimation017Item[];
  onCompleted: () => void;
}

const Animation017: FunctionComponent<IAnimation017Props> = ({
  tip,
  items,
  onCompleted,
}) => {
  const crrRef = useRef() as MutableRefObject<HTMLDivElement>;
  const [play, setPlay] = React.useState(1);
  const [isPlayed, setIsPlayed] = React.useState(false);
  const startPlay = (next = 1) => {
    if (isPlayed) {
      return;
    }
    next += 1;
    setPlay(next);
    setIsPlayed(true);
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1200);
    } else {
      console.log('Animation017 onCompleted');
      onCompleted && onCompleted();
    }
  };
  const getImg = (img: string) =>
    require(`../../../../../assets/${img}`).default;

  return (
    <div className="animation017-content">
      <div
        className="animation017-tip"
        dangerouslySetInnerHTML={{ __html: tip }}
      />
      <div ref={crrRef} className="animation017 component">
        {items.map((itm: IAnimation017Item, idx: number) => (
          <div
            key={idx}
            className={`animation017-item animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
            onClick={() => startPlay()}
            style={{
              width: `${(1 / items.length) * 100 * 2}%`,
            }}
          >
            <img
              className={`click-point ${play > 1 ? 'hide' : ''}`}
              src={ImgPoint}
              alt=""
            />
            {idx % 2 === 0 ? (
              <>
                <div className="animation017-icon">
                  <img src={getImg(itm.icon)} alt="" />
                </div>

                <div
                  className="animation017-line"
                  style={{ backgroundColor: itm.color }}
                />

                <div
                  className="animation017-indicate-number"
                  style={{ color: itm.color }}
                >
                  <div className="number">{itm.number} </div>
                  {itm.line && (
                    <img className="line" src={getImg(itm.line)} alt="" />
                  )}
                </div>

                <div
                  className="animation017-text"
                  dangerouslySetInnerHTML={{ __html: itm.text }}
                />
                <button
                  onClick={() => {
                    window.open(
                      'https://www.pcpd.org.hk/tc_chi/resources_centre/publications/information_leaflet/information_leaflet.html'
                    );
                  }}
                  className="source1"
                />
                <button
                  onClick={() => {
                    window.open(
                      'https://www.pcpd.org.hk/tc_chi/resources_centre/publications/information_leaflet/information_leaflet.html'
                    );
                  }}
                  className="source2"
                />
                <button
                  onClick={() => {
                    window.open(
                      'https://www.pcpd.org.hk/english/resources_centre/publications/information_leaflet/information_leaflet.html'
                    );
                  }}
                  className="source3"
                />
                <button
                  onClick={() => {
                    window.open(
                      'https://www.pcpd.org.hk/english/resources_centre/publications/information_leaflet/information_leaflet.html'
                    );
                  }}
                  className="source4"
                />
              </>
            ) : (
              <>
                <div
                  className="animation017-indicate-number"
                  style={{ color: itm.color }}
                >
                  <div className="number">{itm.number} </div>
                  {itm.line && (
                    <img className="line" src={getImg(itm.line)} alt="" />
                  )}
                </div>

                <div
                  className="animation017-text"
                  dangerouslySetInnerHTML={{ __html: itm.text }}
                />

                <div
                  className="animation017-line"
                  style={{ backgroundColor: itm.color }}
                />

                <div className="animation017-icon">
                  <img src={getImg(itm.icon)} alt="" />
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Animation017;
